export default __webpack_public_path__ + "static/media/be-sure-stepsliide1.2bcc9415.png";